import React, {Dispatch, FC, SetStateAction} from 'react'
import {formSelectedType, WebFormsDataTable} from '../../../../../../app/@types'
import {Download} from '../../../../../../app/features'

const EXPORT_TO_EXCEL = process.env.REACT_APP_EXPORT_TO_EXCEL || 'data-form-excel'

type FormSelectionAndExportProps = {
  uniqueForm: WebFormsDataTable[]
  formSelected: formSelectedType
  setFormSelected: Dispatch<SetStateAction<formSelectedType>>
}

const FormSelectionAndExport: FC<FormSelectionAndExportProps> = ({uniqueForm, formSelected, setFormSelected}) => {

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    if (value) {
      try {
        const obj = JSON.parse(value);
        setFormSelected(obj);
      } catch (error) {
        console.error("Error parsing form selection:", error);
        setFormSelected({
          selected: '',
          params: { type: '' },
          formId: '',
        });
      }
    } else {
      setFormSelected({
        selected: '',
        params: { type: '' },
        formId: '',
      });
    }
  }

  return (
    <form>
      <div className="row d-flex justify-content-start align-items-end mb-5">
        <div className="col-12 col-sm-6 col-md-4 d-flex align-items-center mb-3 mb-sm-0">
          <label htmlFor="formSelected" className="text-gray-400 fs-8 fs-sm-7 me-2 me-sm-">
            Formulaires
          </label>
          <select
            name="formSelected"
            id="formSelected"
            className="form-select form-select-sm form-select-solid"
            onChange={handleChange}
          >
            <option value="">Sélectionner</option>
            {
              uniqueForm.map((form, index) => {

                const optionValue: formSelectedType = {
                  formId: form.data_from === 'wp' ? form.title : form.form_id,
                  params: {type: form.data_from},
                  selected: form.title,
                }

                return (
                  <option key={index} value={JSON.stringify(optionValue)}>
                    {form.title}
                  </option>
                )
              })
            }
          </select>
        </div>
        <div className="col-12 col-sm-6 col-md-4">
          <button
            type="button"
            className="btn btn-sm btn-flex btn-light-success fw-bolder"
            onClick={() =>
              Download({
                api: EXPORT_TO_EXCEL,
                id: `${formSelected.formId}`,
                fileName: `${formSelected.selected}__Web-formulaires`,
                fileExtension: 'xlsx',
                params: formSelected.params,
              })
            }
            disabled={!formSelected.selected}
          >
            <i className="bi bi-file-earmark-spreadsheet fs-2" />
            Exporter mes données
          </button>
        </div>
      </div>
    </form>
  )
}

export {FormSelectionAndExport}